import $ from 'min-jquery';
import { API_URL } from '../../constants';


export const ajaxRequestResetLink = async (data) => {
    let url = `${API_URL}/auth/?do=passremind`;
    const formData = new FormData();
    formData.append('email', data.email);

    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type:'post',
            data,
            success: (response) => {
                resolve(response);
            },
            error: (XMLHttpRequest, textStatus, errorThrown) => {
                reject(textStatus);
            },
          });
    } )

    return true
}
